// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2jq-n","infoBtn":"quickbooks_infoBtn__1v5Gp","formBox":"quickbooks_formBox__36x96","formFooter":"quickbooks_formFooter__1PD-V"};